<template>
  <div >
    <el-dialog class="regin" center :title="title" width="500px" append-to-body :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="formRules">
        <!-- <el-form-item label="版本选择" :label-width="formLabelWidth">
            <el-checkbox v-model="checked3" label="社区版" border></el-checkbox>
            <el-checkbox v-model="checked4" label="企业版" border></el-checkbox>
        </el-form-item> -->
         

        


        

        <el-form-item prop="" :label="switchStatus==0?'用户名':switchStatus==1?'Username':'Имя пользователя'" :label-width="formLabelWidth">
          <el-input v-model="form.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item prop="" :label="switchStatus==0?'设置密码':switchStatus==1?'Password':'Пароль'"  :label-width="formLabelWidth">
          <el-input type="password" v-model="form.password" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item prop=""  :label="switchStatus==0?'公司名称':switchStatus==1?'Company':'Компания'" :label-width="formLabelWidth">
          <el-input v-model="form.company" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item prop=""  :label="switchStatus==0?'手机号码':switchStatus==1?'Phone':'Телефон'"  :label-width="formLabelWidth">
          
          <!-- <el-input v-model="form.region" auto-complete="off"></el-input> -->

          <el-input placeholder=""  auto-complete="off"   v-model="form.region" class="input-with-select" >
           <!-- <div v-if="!switchStatus" slot="prepend" class="Codeph" @click="getPhonecode">
              {{addcode}}
              <i class="el-icon-caret-bottom"></i>
            </div> -->
			<div slot="prepend" class="Codeph" @click="getPhonecode">
			  {{addcode}}
			  <i class="el-icon-caret-bottom"></i>
			</div>
          </el-input>
        
        
        </el-form-item>
        <el-form-item :label="switchStatus==0?'验证码':switchStatus==1?'Code':'Код'" :label-width="formLabelWidth">
          <div class="Code">
              <el-input class="inputs" v-model="form.inputCode" auto-complete="off"></el-input>
              <el-button v-if="switchStatus==0" class="butom" size="small" plain type="primary" @click="smsCode" :disabled="!disabledCodeBtn">获取验证码</el-button>
              <el-button v-if="switchStatus==1" class="butom" size="small" plain type="primary" @click="smsCode" :disabled="!disabledCodeBtn">Get code</el-button>
			  <el-button v-if="switchStatus==2" class="butom" size="small" plain type="primary" @click="smsCode" :disabled="!disabledCodeBtn">Запросить код</el-button>
          </div>
          <span v-if="switchStatus==0" v-show="!show" class="count">{{count}} 秒后重新获取</span>
          <span v-if="switchStatus==1" v-show="!show" class="count">{{count}} Get it again in seconds</span>
		  <span v-if="switchStatus==2" v-show="!show" class="count">получение после {{count}} секунды</span>
        </el-form-item>
       
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false"><span v-if="switchStatus==0">取 消</span><span v-if="switchStatus==1">Cancel</span><span v-if="switchStatus==2">отмена</span></el-button>
        <el-button type="primary" @click="register"><span v-if="switchStatus==0">确 定</span><span v-if="switchStatus==1">Submit</span><span v-if="switchStatus==2">Применить</span></el-button>
      </div>

      <div class="domep" v-show="phflag">
          <!-- <div class="tipls">
            <p>请选择区号</p>
            <p class="ticp" @click="handount"><i class="el-icon-close"></i></p>
          </div> -->
          <ul>
            <li @click="handPhonecode(item)" v-for="item in list" :key="item.code">
              <span>{{item.city}}</span>
              <span>{{item.code}}</span>
            </li>
          </ul>
      </div>


    </el-dialog>
  </div>
</template>
<script>
import methodlist from '../../../utils/methods'
export default {
  name: 'Regest',
  data () {
    return {
      phflag:false,
      addcode:'+86',
      message: '手机号码输入有误',
      title: '新用户注册',
      form: {
        name: '',
        region: '',
        password:'',
        company:'',
        inputCode:'',
        smscode:''
      },

      dialogFormVisible: false,
      disabledCodeBtn:true,
      formLabelWidth: '120px',
      formRules: { 
        name: [
          { required: true, message: '姓名不能为空', trigger: 'blur' }
        ],
        region: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          // { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的号码格式', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' }
        ],
        inputCode:[
          { required: true, message: '验证码不能为空', trigger: 'blur' }
        ]
      },
      show: true,
      count: '',
      timer: null,
      // list:
    }
  },

  props:{
    langflag:Number
  },
  computed: {
    switchStatus: function () {
      return this.langflag // 直接监听props里的status状态
    },
    list:function(){
      return[
          {
              "city": this.$t('zgdl'),
              "code": "+86"
          },
          {
              "city": this.$t('zgxg'),
              "code": "+852"
          },
          {
              "city": this.$t('zgam'),
              "code": "+853"
          },
          {
              "city": this.$t('zgtw'),
              "code": "+886"
          },
          {
            "city": this.$t('afh'),
            "code": "+93"
            },
            {
                "city": this.$t('ade'),
                "code": "+376"
            },
            {
                "city": this.$t('alq'),
                "code": "+971"
            },
            {
                "city": this.$t('agt'),
                "code": "+54"
            },
            {
                "city": this.$t('aejly'),
                "code": "+213"
            },
            {
                "city": this.$t('am'),
                "code": "+968"
            },
            {
                "city": this.$t('ymny'),
                "code": "+374"
            },
            {
                "city": this.$t('alb'),
                "code": "+297"
            },
            {
                "city": this.$t('adl'),
                "code": "+43"
            },
            {
                "city": this.$t('asbj'),
                "code": "+994"
            },
            {
                "city": this.$t('bhm'),
                "code": "+1242"
            },
            {
                "city": this.$t('bl'),
                "code": "+973"
            },
            
            {
                "city": this.$t('bbds'),
                "code": "+1246"
            },
            {
                "city": this.$t('blst'),
                "code": "+970"
            },
            {
                "city": this.$t('bels'),
                "code": "+375"
            },
            {
                "city": this.$t('bls'),
                "code": "+32"
            },
            {
                "city": this.$t('bjst'),
                "code": "+92"
            },
			{
			    "city": this.$t('bx'),
			    "code": "+55"
			},
            {
                "city": this.$t('cxx'),
                "code": "+850"
            },
            {
                "city": this.$t('cdjny'),
                "code": "+240"
            },
            {
                "city": this.$t('dg'),
                "code": "+49"
            },
            {
                "city": this.$t('dm'),
                "code": "+45"
            },
            {
                "city": this.$t('jbt'),
                "code": "+253"
            },
            {
                "city": this.$t('dmnjghg'),
                "code": "+1890"
            },
            {
                "city": this.$t('els'),
                "code": "+7"
            },
            {
                "city": this.$t('egde'),
                "code": "+593"
            },
            {
                "city": this.$t('aj'),
                "code": "+20"
            },
            {
                "city": this.$t('aseby'),
                "code": "+251"
            },
            {
                "city": this.$t('fg'),
                "code": "+33"
            },
            {
                "city": this.$t('fl'),
                "code": "+358"
            },
            {
                "city": this.$t('flb'),
                "code": "+63"
            },
            {
                "city": this.$t('fdg'),
                "code": "+379"
            },
            {
                "city": this.$t('gby'),
                "code": "+220"
            },
            {
                "city": this.$t('ggghg'),
                "code": "+242"
            },
            {
                "city": this.$t('glby'),
                "code": "+57"
            },
            {
                "city": this.$t('gba'),
                "code": "+53"
            },
            {
                "city": this.$t('gljy'),
                "code": "+995"
            },
            {
                "city": this.$t('hg'),
                "code": "+82"
            },
            {
                "city": this.$t('hl'),
                "code": "+31"
            },
            
            {
                "city": this.$t('hd'),
                "code": "+509"
            },
          {
                "city": this.$t('jbz'),
                "code": "+855"
            },
            {
                "city": this.$t('jlbs'),
                "code": "+686"
            },
            {
                "city": this.$t('jny'),
                "code": "+224"
            },
            {
                "city": this.$t('jbbw'),
                "code": "+263"
            },
            {
                "city": this.$t('kml'),
                "code": "+237"
            },
            {
                "city": this.$t('kmqt'),
                "code": "+1345"
            },
            {
                "city": this.$t('kny'),
                "code": "+254"
            },
            {
                "city": this.$t('kwt'),
                "code": "+965"
            },
            {
                "city": this.$t('kldy'),
                "code": "+385"
            },
            {
                "city": this.$t('kte'),
                "code": "+974"
            },
          {
                "city": this.$t('lys'),
                "code": "+856"
            },
            {
                "city": this.$t('lby'),
                "code": "+218"
            },
            {
                "city": this.$t('lwd'),
                "code": "+250"
            },
            {
                "city": this.$t('md'),
                "code": "+95"
            },
            {
                "city": this.$t('mlg'),
                "code": "+212"
            },
            {
                "city": this.$t('mg'),
                "code": "+1"
            },
            {
                "city": this.$t('mlxy'),
                "code": "+60"
            },
            
            {
                "city": this.$t('mxg'),
                "code": "+52"
            },
            {
                "city": this.$t('nf'),
                "code": "+27"
            },
            {
                "city": this.$t('nbe'),
                "code": "+977"
            },
            {
                "city": this.$t('nrly'),
                "code": "+234"
            },
            {
                "city": this.$t('nw'),
                "code": "+47"
            },
            {
                "city": this.$t('plqd'),
                "code": "+680"
            },
            {
                "city": this.$t('pty'),
                "code": "+351"
            },
            {
                "city": this.$t('rb'),
                "code": "+81"
            },
            {
                "city": this.$t('rd'),
                "code": "+46"
            },
            {
                "city": this.$t('rs'),
                "code": "+41"
            },
            {
                "city": this.$t('stalb'),
                "code": "+966"
            },
            {
                "city": this.$t('sd'),
                "code": "+249"
            },
            {
                "city": this.$t('slxy'),
                "code": "+1758"
            },
             {
                  "city": this.$t('tgs'),
                  "code": "+66"
              },
              {
                  "city": this.$t('tjs'),
                  "code": "+676"
              },
            
            {
                "city": this.$t('teq'),
                "code": "+90"
            },
            {
                "city": this.$t('tns'),
                "code": "+216"
            },
            {
                "city": this.$t('wnrl'),
                "code": "+58"
            },
            {
                "city": this.$t('wl'),
                "code": "+673"
            },
            {
                "city": this.$t('wkl'),
                "code": "+380"
            },
            {
                "city":this.$t('xxl'),
                "code": "+64"
            },
            {
                "city": this.$t('xjb'),
                "code": "+65"
            },
            {
                "city": this.$t('xby'),
                "code": "+34"
            },
            {
                "city": this.$t('xl'),
                "code": "+30"
            },
            {
                "city": this.$t('xly'),
                "code": "+963"
            },
            {
                "city": this.$t('xyl'),
                "code": "+36"
            },
            {
                "city": this.$t('ydl'),
                "code": "+39"
            },
            {
                "city": this.$t('yg'),
                "code": "+44"
            },
            {
                "city": this.$t('ydnxy'),
                "code": "+62"
            },
            {
                "city": this.$t('yd'),
                "code": "+91"
            },
            {
                "city": this.$t('yl'),
                "code": "+98"
            },
            {
                "city": this.$t('ylk'),
                "code": "+964"
            },
            {
                "city": this.$t('ysl'),
                "code": "+972"
            },
            {
                "city": this.$t('yn'),
                "code": "+84"
            },
            {
                "city": this.$t('ym'),
                "code": "+967"
            },
            
            {
                "city": this.$t('zl'),
                "code": "+56"
            },
            {
                "city": this.$t('zfghg'),
                "code": "+236"
            },

      ]
    }
  },
  watch:{
    'switchStatus':function(nv,ol){
      if(nv==0){
        this.message = '手机号码输入有误'
        this.title='新用户注册'
        this.$i18n.locale = 'cn'
      } else if(nv==1){
          this.message = 'Wrong input of mobile phone number'
          this.title='Registration'
          this.$i18n.locale = 'en'
      }else if(nv==2){
          this.message = 'Ошибка при вводе номера телефона'
          this.title='Регистрация'
          this.$i18n.locale = 're'
      }
    }
  },
  mounted(){
     
  },
  methods:{
    handount(){
      this.phflag = false
    },
    getPhonecode(){
      this.phflag = !this.phflag
    },
    handPhonecode(item){
      console.log(item.code)
      this.addcode =item.code
      this.phflag = false
    },
    smsCode:function(){
      if(!this.form.name){
        this.$message({
          type: 'error',
          message: this.$t('qtxyhm')
        });
        return false
      }
      // if (!/^1[3456789]\d{9}$/.test(this.form.region)){
      //     this.$message({
      //         message:  this.message,
      //         center: true,
      //         duration:2000,
      //         offset:100
      //     });
      //     return false;
      // }
      // 18251375998
      let mobiles = ""
      if(this.addcode!='+86'){
         mobiles = this.addcode + '-' + this.form.region
      }else{
         mobiles =  this.form.region
      }
      // console.log(mobiles)
      // return false
      const params = {
        method: methodlist.ee_sms_code,
        name: this.form.name, 
        mobile: mobiles,
        type:0
      }
      console.log(params);
      this.$serve(params).then(res => {
        console.log(res)
        if(res.data.code == 0){
            this.form.smscode = res.data.data.verify_code;
        }else{
          if(res.data.code == -4){
            this.$message({
              type: 'warning',
              message: this.$t('yhmycz')
            });
          }else{
            this.$message({
              type: 'warning',
              message: this.$t('hqsb')
            });
          }
        }
        
      })

      const TIME_COUNT = 60;
      this.disabledCodeBtn = false;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
            this.disabledCodeBtn = true;
          }
        }, 1000)
      }
    },
    
    register:function(){
      if(this.form.name.length ==0 ){
          this.$message({
            type: 'warning',
            message: this.$t('yhmbnwk')
          });
          return false;
      }

      if(this.form.password.length ==0 ){
          this.$message({
            type: 'warning',
            message: this.$t('mmbnwk')
          });
          return false;
      }

      if(this.form.company.length ==0 ){
          this.$message({
            type: 'warning',
            message: this.$t('gsmcbnwk')
          });
          return false;
      }

      if(this.form.region.length ==0 ){
          this.$message({
            type: 'warning',
            message: this.$t('sjhmbnwk')
          });
          return false;
      }

      if(this.form.inputCode.length ==0 ){
          this.$message({
            type: 'warning',
            message: this.$t('yzmbnwk')
          });
          return false;
      }
      let mobile = ""
      if(this.addcode!='+86'){
         mobile = this.addcode + '-' + this.form.region
      }else{
         mobile =  this.form.region
      }
      
      const params = {
          method: methodlist.ee_register,
          name: this.form.name, 
          mobile: mobile, 
          password: this.$md5(this.form.password),
          verify_code:this.form.inputCode,
          version_type:1,
          enterprise_name:this.form.company       
      }

      this.$serve(params).then(res => {
        console.log(res)
        if(res.data.code == 0){
          this.$message({
            type: 'success',
            message: '注册成功!'
          })          
          this.dialogFormVisible = false;
        }else{
          var mess_hint ='注册失败';
          if(res.data.code == -4){
            mess_hint = ' 账号已存在';
          }else if(res.data.code == -7){
            mess_hint = ' 验证码不正确';
          }
          this.$message({
            type: 'warning',
            message: mess_hint               
          });
        }
      })
    },
    openViewType(flag){
      if(flag == 0)
        this.title = "新用户注册";
      else
        this.title = "找回密码";
    }
  }
}
</script>
<style lang="less" scoped>

.eregin .el-dialog /deep/ .el-dialog__header{
  border-bottom: 1px solid #000;
}
.el-form{
  width: 85%;
  .Code{
    width: 100%;
    display: flex;
    .inputs{
      flex:3;
      margin-right: 20px;
    }
    .butom{
      flex: 1;
    }
  }
  .count{
    font-size: 20px;
    color: red;
  }
}
.Codeph{
  position: relative;
  cursor: pointer;
}
.domep{
  width: 230px;
  height: 340px;
  border-radius: 5px;
  padding:0 18px 18px 18px;
  border: 1px solid #ccc;
  position: absolute;
  top: 125px;
  left: 142px ;
  background-color:white ;
  box-shadow:0px 0px 6px rgb(0 0 0 / 20%);
  color: #444444;
  overflow: hidden;
  overflow:auto
}
.ticp{
  cursor: pointer;
  font-size: 18px;
}
.tipls{
  height: 40px ;
  line-height: 40px;
  border-bottom:1px solid #ccc ;
  display: flex;
  justify-content: space-between;
}
.domep ul{
  list-style-type: none;
  padding: 0;
  margin: 0;
  
}
.domep ul li{
  line-height: 40px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ccc;
  padding: 0 10px;
  cursor: pointer;
}
</style>
